import { useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import { DefaultTrackingContainer } from '@/modules/pmt/components/DefaultTrackingContainer';
import { SyncInProgressBanner } from '@/modules/pmt/components/SyncInProgressBanner';
import { NoParcelAddedYet } from '../NoParcels';

const DesktopLayout = () => {
  return (
    <>
      <SyncInProgressBanner />
      <NoParcelAddedYet />
    </>
  );
};

const MobileLayout = () => {
  return <DefaultTrackingContainer showEmailConnectedBanner />;
};

export const NoShipmentsLayout = () => {
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);
  return isDesktopPMT ? <DesktopLayout /> : <MobileLayout />;
};
